import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import QuizTypes from 'types/QuizTypes';

const LeaderboardButton:FC = () => {
  const { t } = useTranslation('common');
  const navigateTo = useNavigateTo();

  const quiz:any = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const isPollQuiz = quiz.type === QuizTypes.Poll;

  const handleClick = () => {
    if (isPollQuiz) {
      navigateTo('results');
    } else {
      navigateTo('leaderboard');
    }
  }

  const label = quiz.proceedButtonTitle
    ? quiz.proceedButtonTitle
    : isPollQuiz
      ? t('common.results')
      : t('common.leaderboard')

  const isDisabled = !isPollQuiz && !result;

  if ( quiz.type === QuizTypes.Personality ) return null;

  return (
    <div className="text-center mb-4">
      <Button
        disableShadow={isPollQuiz}
        className={`
          ${isPollQuiz
            ? 'w-full text-2xl uppercase text-white bg-gradient-to-b from-[#facc22] to-[#f83600] hover:from-[#f83600] hover:to-[#facc22]'
            : 'capitalize'
          }
        `}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {label}
      </Button>
    </div>
  )
}

export default LeaderboardButton;
